/* Native product data and standard Shopify product form; local mode never submits. */
(() => {
  if (customElements.get('kt-litter-purchase')) return;
  const moneyNodes = () => document.querySelectorAll('[data-lf-price]');
  const modelNodes = () => document.querySelectorAll('[data-lf-model]');
  class LitterPurchase extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (el, name, cb) => el?.addEventListener(name, cb, { signal, capture:name==='scroll', passive:name==='scroll' });
      const image = this.querySelector('.lf-main-image img');
      const submit = this.querySelector('[data-lf-submit]');
      const select = input => {
        if (!input) return;
        modelNodes().forEach(n => n.textContent = input.dataset.title);
        moneyNodes().forEach(n => n.textContent = input.dataset.price);
        submit.disabled = this.dataset.local === 'true' || input.dataset.available !== 'true';
        submit.firstChild.textContent = (input.dataset.available === 'true' ? submit.dataset.availableLabel : submit.dataset.soldLabel) + ' ';
        if (input.dataset.image) { image.src = input.dataset.image; this.querySelectorAll('[data-lf-image]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.lfImage === input.dataset.image))); }
        const models = document.querySelector('[data-lf-measurements]');
        const match = models && JSON.parse(models.textContent).find(m => (input.dataset.model || input.dataset.title) === m.name);
        if (match) document.querySelectorAll('[data-lf-spec-dim]').forEach(n => n.textContent = match.mm);
        if (this.dataset.local !== 'true') {
          const url = new URL(location.href); url.searchParams.set('variant', input.value); history.replaceState(null, '', url);
        }
      };
      this.querySelectorAll('[data-lf-variant]').forEach(input => on(input, 'change', () => select(input)));
      select(this.querySelector('[data-lf-variant]:checked'));
      const gallery = [...this.querySelectorAll('[data-lf-image]')];
      gallery.forEach((b,i) => on(b, 'click', () => {image.src = b.dataset.lfImage; image.alt = b.querySelector('img').alt; gallery.forEach(x => x.setAttribute('aria-pressed', String(x === b))); this.querySelector('[data-lf-gallery-count]').textContent = `${String(i+1).padStart(2,'0')} / 03`;}));
      this.querySelectorAll('[data-lf-gallery-step]').forEach(b => on(b,'click',()=>{const i=gallery.findIndex(x=>x.getAttribute('aria-pressed')==='true');gallery[(i+Number(b.dataset.lfGalleryStep)+gallery.length)%gallery.length].click();}));
      const quantity = this.querySelector('[name=quantity]');
      this.querySelectorAll('[data-lf-quantity]').forEach(b => on(b, 'click', () => {quantity.value = Math.max(1, Math.min(99, (Number(quantity.value) || 1) + Number(b.dataset.lfQuantity))); quantity.dispatchEvent(new Event('change', { bubbles:true }));}));
      on(quantity, 'change', () => quantity.value = Math.max(1, Math.min(99, Number(quantity.value) || 1)));
      on(this.querySelector('form'), 'submit', e => { if (this.dataset.local === 'true') e.preventDefault(); });
      on(document, 'click', e => {
        const link = e.target.closest('.lf a[href^="#"], a[href^="#service-"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        if (target.tagName === 'DETAILS') target.open = true;
        if (link.hash === '#purchase') requestAnimationFrame(() => this.focus({ preventScroll:true }));
      });
      const bar = document.querySelector('.lf-sticky');
      // Observe the in-page CTA, never the floating bar's own button.
      const close = document.querySelector('#purchase-close .pv-close-select, #purchase-close .lf-close-grid .lf-button');
      if (bar && close) {
        let barRaf = 0;
        const updateBar = () => {
          barRaf = 0;
          const end = close.getBoundingClientRect();
          const hidden = submit.getBoundingClientRect().bottom >= 0 || (end.top < innerHeight && end.bottom > 0);
          if (bar.hidden !== hidden) bar.hidden = hidden;
        };
        on(document, 'scroll', () => {if (!barRaf) barRaf = requestAnimationFrame(updateBar);});
        on(window, 'resize', updateBar);
        signal.addEventListener('abort', () => cancelAnimationFrame(barRaf));
        updateBar();
      }
      const nav = document.querySelector('.lf-nav');
      if (nav) {
        const links = [...nav.querySelectorAll('.lf-nav-links a')];
        links.forEach(a => a.hidden = !document.getElementById(a.hash.slice(1)));
        const targets = links.map(a => document.getElementById(a.hash.slice(1))).filter(Boolean);
        let raf = 0;
        const update = () => {raf = 0; const visible = targets.filter(t => t.getBoundingClientRect().top <= 160).at(-1) || targets[0]; links.forEach(a => a.hash === '#' + visible?.id ? a.setAttribute('aria-current', 'location') : a.removeAttribute('aria-current'));};
        on(document, 'scroll', () => {if (!raf) raf = requestAnimationFrame(update);});
        signal.addEventListener('abort', () => cancelAnimationFrame(raf)); update();
      }
      const dialog = document.querySelector('.lf-video');
      if (dialog) {
        on(document.querySelector('[data-lf-video-open]'), 'click', () => dialog.showModal());
        on(dialog.querySelector('[data-lf-video-close]'), 'click', () => dialog.close());
        on(dialog, 'close', () => dialog.querySelector('video').pause());
        on(dialog, 'click', e => {if (e.target === dialog) dialog.close();});
      }
    }
    disconnectedCallback() {this.controller?.abort(); this.observer?.disconnect();}
  }
  class LitterSize extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const models = JSON.parse(this.querySelector('[data-lf-measurements]').textContent);
      this.querySelectorAll('[data-lf-size]').forEach(b => b.addEventListener('click', () => {
        const model = JSON.parse(this.querySelector('[data-lf-measurements]').textContent)[Number(b.dataset.lfSize)];
        this.querySelectorAll('[data-measure]').forEach(n => n.textContent = model[n.dataset.measure]);
        this.querySelectorAll('[data-lf-size]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      }, {signal:this.controller.signal}));
    }
    disconnectedCallback() {this.controller?.abort();}
  }
  customElements.define('kt-litter-purchase', LitterPurchase);
  customElements.define('kt-litter-size', LitterSize);
  document.addEventListener('shopify:section:load', () => document.querySelector('kt-litter-purchase')?.connectedCallback());
})();
